import React from "react";
import { Button } from "./ui/button";
import { Calculator, Home, FileText, Building, Paintbrush, Shield, Clock, Star } from "lucide-react";

const ServiceSection = () => {
  const services = [
    {
      icon: Paintbrush,
      iconBg: "bg-gradient-to-br from-cyan-500 to-blue-600",
      title: "🎨 Innenanstriche",
      description: "Raumgestaltende Innenanstriche von Wohnräumen, Büros bis Laboren. Hochwertige Silikat-, Dispersions- und Latexfarben für jeden Verwendungszweck."
    },
    {
      icon: Calculator,
      iconBg: "bg-gradient-to-br from-purple-500 to-pink-600", 
      title: "💰 Festpreis-System",
      description: "Transparente Preiskalkulation durch Aufmaß vor Ort. Kosten- und Terminsicherheit durch detaillierte Angebote und Terminabsprache."
    },
    {
      icon: Shield,
      iconBg: "bg-gradient-to-br from-green-400 to-emerald-600",
      title: "⭐ Fachbetrieb",
      description: "Erfahrene Maler mit umfassendem Fachwissen. Individuelle Beratung und sorgfältige Planung für optimale Malerergebnisse."
    },
    {
      icon: Clock,
      iconBg: "bg-gradient-to-br from-orange-500 to-red-600",
      title: "⚡ Airless-Technik",
      description: "Modernste Airless-Spritztechnik für gleichmäßige Oberflächen. Schnelle und professionelle Ausführung großer Flächen."
    }
  ];

  return (
    <section className="py-8 md:py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-purple-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6 drop-shadow-lg">
            🎨 Professionelle Malerarbeiten in Baden-Württemberg
          </h2>
          <h3 className="text-2xl lg:text-3xl text-cyan-400 mb-8 drop-shadow-md">
            Moderne Airless-Technologie zum Festpreis
          </h3>
          <p className="text-lg text-gray-300 max-w-4xl mx-auto leading-relaxed">
            Der Innenraumgestaltung wird ein hoher Stellenwert zugeschrieben - mit unserem umfangreichen 
            Repertoire an qualitativen Malerleistungen und modernster Airless-Spritztechnik decken wir 
            zahlreiche Arbeitsgebiete ab. Transparente Festpreise nach Quadratmetern - fair und ohne versteckte Kosten.
          </p>
        </div>

        {/* Service Icons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {services.map((service, index) => {
            const IconComponent = service.icon;
            return (
              <div key={index} className="text-center group">
                <div className="mb-6">
                  <div className={`${service.iconBg} w-24 h-24 rounded-full flex items-center justify-center mx-auto shadow-2xl group-hover:shadow-cyan-500/50 transition-all duration-500 transform group-hover:scale-110 group-hover:rotate-6 border-2 border-white/20`}>
                    <IconComponent className="w-12 h-12 text-white drop-shadow-lg" />
                  </div>
                </div>
                <h4 className="text-xl font-bold text-white mb-4 group-hover:text-cyan-400 transition-colors duration-300 drop-shadow-md">
                  {service.title}
                </h4>
                <p className="text-gray-300 leading-relaxed group-hover:text-white transition-colors duration-300">
                  {service.description}
                </p>
              </div>
            );
          })}
        </div>

        {/* Airless Gallery Section */}
        <div className="mb-16">
          {/* Section removed - no gallery photos */}
        </div>

        {/* CTA Section */}
        <div className="text-center">
          <div className="bg-gradient-to-br from-gray-800 to-gray-900 rounded-2xl p-8 max-w-2xl mx-auto border border-cyan-500/30 shadow-lg shadow-cyan-500/20">
            <h3 className="text-2xl font-bold text-white mb-4 drop-shadow-lg">🎨 Airless-Profi-Technik</h3>
            <p className="text-lg text-cyan-200">
              Modernste Spritzverfahren für gleichmäßige und streifenfreie Oberflächen
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServiceSection;